/* global window */
const React = require('react');
const serialize = require('serialize-javascript');
const Head = require('react-declarative-head');
const Script = require('nordic/script');
const canUseDOM = require('../../../utils/enabledDOM');
const { TRACK_COOKIES_TITLE } = require('../../../utils/constants/common');

const { useEffect } = React;

function TrackCookies(props) {
  const { cookiesData, trackId } = props;

  useEffect(() => {
    if (canUseDOM()) {
      window.parent.postMessage({
        ...cookiesData,
        trackId,
      }, '*');
    }
  }, [canUseDOM]);

  return (
    <>
      <Head>
        <title>{TRACK_COOKIES_TITLE}</title>
      </Head>

      <Script>
        {`
          window.__PRELOADED_STATE__ = ${serialize({ ...props }, { isJSON: true }) || {}};
        `}
      </Script>
      <Script type="text/javascript" src="https://cdn.polyfill.io/v3/polyfill.min.js?features=es5,es6&flags=gated" />
      <Script src="vendor.js" />
      <Script src="trackCookies.js" />
    </>
  );
}

module.exports = TrackCookies;
